<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :md="6" :sm="24">
            <a-form-item label="类别">
              <a-input placeholder="请输入类别" v-model="queryParam.category"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="8" :md="8" :sm="24">
            <a-form-item label="时间">
              <a-date-picker
                @change="onTimeChange"
                format="YYYY-MM-DD"
                v-model="clearDate"
                style="width: 100%"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="8" :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
              <a-button @click="() => {queryParam = {}, clearDate = undefined}" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.SxMaterialAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :columns="columns"
      :data="loadData"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span>
            <a @click="$refs.SxMaterialAddOrUpdate.init(record.id,'show')">详情</a>
            <a-divider type="vertical" />
          </span>
          <span>
            <a @click="$refs.SxMaterialAddOrUpdate.init(record.id,'edit')">修改</a>
            <a-divider type="vertical" />
          </span>
          <span>
            <a-popconfirm title="是否删除" @confirm="deleteItem(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </div>
      </span>
    </s-table>
    <sx-material-add-or-update
      @ok="queryPage"
      ref="SxMaterialAddOrUpdate"
    />
  </a-card>
</template>

<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/common/SxMaterial'
import { enterEvent } from '@/utils/util'
import SxMaterialAddOrUpdate from './SxMaterialAddOrUpdate'
export default {
  name: 'SxMaterialView',
  components: { SxMaterialAddOrUpdate },
  mixins: [TableMixin],
  data () {
    return {
      projectList: [],
      clearDate: undefined,
      dateFormat: 'YYYY/MM/DD',
      queryParam: {
        category: undefined,
        name: undefined,
        clearDate: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '类别',
          dataIndex: 'category'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '规格',
          dataIndex: 'format'
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
        {
          title: '落地单价',
          dataIndex: 'price'
        },
        {
          title: '苗源及质量标准',
          dataIndex: 'remark'
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.init()
    enterEvent(this.queryPage)
  },
  methods: {
    init () {
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    onTimeChange (date, dateString) {
      if (date !== null) {
        this.queryParam.date = date.format('YYYY-MM-DD')
      } else {
        this.queryParam.date = undefined
      }
    }
  }
}
</script>
